module.exports = __webpack_public_path__ + "static/media/IMG_4235.7468ce7f.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/img/pokoje/IMG_4235.JPG
// module id = 93
// module chunks = 0